import React from "react"
import "./App.css"
import AppRouter from "./components/Approuter"
import AuthContextProvider from "./context/AuthContext"

function App() {
  return (
    <div className="">
      <AuthContextProvider>
        <AppRouter />
      </AuthContextProvider>
    </div>
  )
}

export default App
